var exports = {
  "U": "xdbfd91f1--8a3c55--photo_gallery_container",
};

module.exports = exports;
